import { emailResponseTimeDefaultVal } from "../../../common/shared";

export const MemberNameChangeDefaults = {
  captchaResponse: '',
  captchaIsInvalid: true,
  emailResponseTime: emailResponseTimeDefaultVal,
  showRecaptcha: false,
  backgroundColor: 'primary',
  isSubmitError: false,
  isSubmitted: false,
  invalidItemNumbers: [],
  showREIHome: false,
  disableSubmit: true,
  validFields: [],
  changeIntended: 'first-full-name',
  changeIntendedValidationMap: {
    'first-full-name': 'FIRST_FULL_NAME',
    'last-name': 'LAST_NAME',
  },
  currentFirstName: '',
  currentLastName: '',
  currentMiddleInitial: '',
  updatedFirstName: '',
  updatedLastName: '',
  updatedMiddleInitial: '',
  additionalComments: '',
  additionalCommentsMaxLimit: 300,
  additionalCommentsTypeErrorMessage: '',
  emailAddress: '',
  membershipNumber: '',
  membershipValidationType: '',
  membershipValidationDetail: '',
  membershipValidationDetailLabel: '',
  membershipValidationDetailHelperText: '',
  membershipValidationDetailLabelCopyTop: {
    'original-address': 'What is the address? *',
    'purchase-location': 'Specify REI store city and state or REI.com *',
    'membership-purchases': 'List 2–3 items purchased *',
  },
  membershipMethodParser: {
    'original-address': 'ORIGINAL_ADDRESS_ASSOCIATED_WITH_MEMBERSHIP',
    'purchase-location': 'MEMBERSHIP_PURCHASE_LOCATION',
    'membership-purchases': 'PAST_MEMBERSHIP_PURCHASES',
  },
  membershipValidationDetailLabelCopyBottom: {
    'membership-purchases': 'Specify details like product name, brand, size, color',
  },
  membershipAnalyticsTags: {
    'original-address': 'original_address',
    'purchase-location': 'purchase_location',
    'membership-purchases': 'past_purchase',
  },
  membershipValidationDetailMaxLimit: 300,
  membershipValidationDetailTypeErrorMessage: '',
  invalidCurrentFirstName: false,
  invalidCurrentLastName: false,
  invalidCurrentMiddleInitial: false,
  invalidUpdatedFirstName: false,
  invalidUpdatedLastName: false,
  invalidUpdatedMiddleInitial: false,
  invalidAdditionalComments: false,
  invalidMembershipNumber: false,
  invalidMembershipValidationType: false,
  invalidMembershipValidationDetail: false,
  invalidEmail: false,
  captchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  enableCaptcha: false,
}